import { render, staticRenderFns } from "./mlc.vue?vue&type=template&id=1638b94d&"
import script from "./mlc.vue?vue&type=script&lang=js&"
export * from "./mlc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports